import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
export function AboutSection() {
  const {
    language
  } = useLanguage();
  const t = translations[language];
  return <section id="about" className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-8 text-center" data-id="element-14">
          {t.about.title}
        </h2>

        <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-15">
          <p data-id="element-16">{t.about.p1}</p>
          <p data-id="element-17">{t.about.p2}</p>
          <p data-id="element-18">{t.about.p3}</p>
        </div>
      </div>
    </section>;
}